<template>
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Pending Licence Approval</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="County Liquor Licensing System" name="description" />
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Header -->
          <div class="row">
            <div class="col-12">
              <div class="page-header-box mb-4">
                <h4 class="page-header-title">PENDING LICENCE APPROVAL</h4>
                <p class="page-header-description">Review and approve fully paid liquor licence applications (Stage 4 → Stage 5)</p>
              </div>
            </div>
          </div>

          <!-- Toolbar -->
          <ToolBarLiquor/>

          <!-- Statistics Cards -->
          <div class="row">
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card stats-card h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <p class="text-muted mb-2 fw-semibold">Total at Stage 4</p>
                      <h3 class="mb-0 fw-bold">{{ stats.totalAtStage4 }}</h3>
                      <div class="d-flex align-items-center mt-2">
                        <span class="badge bg-soft-info text-info me-2">Court Review Passed</span>
                      </div>
                    </div>
                    <div class="stats-icon bg-gradient-info">
                      <i class="bx bx-list-check"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card stats-card h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <p class="text-muted mb-2 fw-semibold">Ready for Approval</p>
                      <h3 class="mb-0 fw-bold text-success">{{ stats.pendingApproval }}</h3>
                      <div class="d-flex align-items-center mt-2">
                        <span class="badge bg-soft-success text-success me-2">Fully Paid</span>
                      </div>
                    </div>
                    <div class="stats-icon bg-gradient-success">
                      <i class="bx bx-check-circle"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card stats-card h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <p class="text-muted mb-2 fw-semibold">Awaiting Payment</p>
                      <h3 class="mb-0 fw-bold text-warning">{{ stats.awaitingPayment }}</h3>
                      <div class="d-flex align-items-center mt-2">
                        <small class="text-muted">{{ formatCurrency(stats.awaitingPaymentAmount) }} pending</small>
                      </div>
                    </div>
                    <div class="stats-icon bg-gradient-warning">
                      <i class="bx bx-wallet"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card stats-card h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <p class="text-muted mb-2 fw-semibold">Approved This Month</p>
                      <h3 class="mb-0 fw-bold">{{ stats.approvedThisMonth }}</h3>
                      <div class="d-flex align-items-center mt-2">
                        <span class="badge bg-soft-primary text-primary me-2">Today: {{ stats.approvedToday }}</span>
                      </div>
                    </div>
                    <div class="stats-icon bg-gradient-primary">
                      <i class="bx bx-badge-check"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Table Card -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <!-- Card Header -->
                <div class="card-header bg-white border-bottom">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <!-- Left: Title with Icon -->
                    <div class="d-flex align-items-center">
                      <div class="header-icon me-3">
                        <i class="bx bx-hourglass"></i>
                      </div>
                      <div>
                        <h4 class="card-title mb-0 text-uppercase fw-bold">Applications Pending Approval</h4>
                        <small class="text-muted">Fully paid applications awaiting final licence approval</small>
                      </div>
                    </div>

                    <!-- Right: Search and Actions -->
                    <div class="d-flex flex-wrap align-items-center gap-2">
                      <div class="search-box">
                        <input v-model="search" type="text" class="form-control" placeholder="Search...">
                        <i class="bx bx-search search-icon"></i>
                      </div>

                      <select v-model="paymentFilter" class="form-select" style="width: 160px;">
                        <option value="all">All Applications</option>
                        <option value="paid">Fully Paid</option>
                        <option value="unpaid">Awaiting Payment</option>
                      </select>

                      <!-- Bulk Approve Button -->
                      <button
                          v-if="selectedApplications.length > 0"
                          @click="showBulkApproveModal"
                          class="btn btn-success">
                        <i class="bx bx-check-double me-1"></i>
                        Approve Selected ({{ selectedApplications.length }})
                      </button>

                      <button @click="refreshData" class="btn btn-soft-primary">
                        <i class="bx bx-refresh me-1"></i> Refresh
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Location and Date Filters -->
                <div class="card-header bg-white border-bottom">
                  <div class="row g-3 align-items-end">
                    <!-- Sub County Filter -->
                    <div class="col-md-3">
                      <label class="form-label mb-1">Sub County:</label>
                      <select class="form-select" v-model="subCounty" @change="onSubCountyChange">
                        <option value="">All Sub Counties</option>
                        <option v-for="item in subCounties" :key="item.subCountyID" :value="item">
                          {{ item.subCountyName }}
                        </option>
                      </select>
                    </div>

                    <!-- Ward Filter -->
                    <div class="col-md-3">
                      <label class="form-label mb-1">Ward:</label>
                      <select class="form-select" v-model="ward" @change="onWardChange">
                        <option value="">All Wards</option>
                        <option v-for="item in wards" :key="item.wardID" :value="item">
                          {{ item.wardName }}
                        </option>
                      </select>
                    </div>

                    <!-- Date From -->
                    <div class="col-md-3">
                      <label class="form-label mb-1">From:</label>
                      <input v-model="dateFrom" type="date" class="form-control">
                    </div>

                    <!-- Date To -->
                    <div class="col-md-3">
                      <label class="form-label mb-1">To:</label>
                      <input v-model="dateTo" type="date" class="form-control">
                    </div>
                  </div>
                </div>

                <!-- Card Body -->
                <div class="card-body p-0">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <h5 class="text-muted">Loading applications...</h5>
                    <p class="text-muted small">Please wait while we fetch pending approvals</p>
                  </div>

                  <!-- Empty State -->
                  <div v-else-if="applications.length === 0" class="text-center py-5">
                    <div class="empty-state-icon mb-3">
                      <i class="bx bx-check-circle"></i>
                    </div>
                    <h5 class="text-muted">No Pending Approvals</h5>
                    <p class="text-muted small mb-3">All eligible applications have been approved</p>
                    <button @click="resetFilters" class="btn btn-soft-primary">
                      <i class="bx bx-refresh me-1"></i> Reset Filters
                    </button>
                  </div>

                  <!-- Data Table -->
                  <div v-else class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="table-light">
                      <tr>
                        <th class="ps-3">
                          <div class="form-check">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :checked="isAllSelected"
                                @change="toggleSelectAll"
                                :disabled="paymentFilter !== 'paid'">
                          </div>
                        </th>
                        <th>#</th>
                        <th>Licence Bill No.</th>
                        <th>Business</th>
                        <th>Applicant</th>
                        <th>Licence Category</th>
                        <th>Location</th>
                        <th>Date Inspected</th>
                        <th class="text-end">Amount</th>
                        <th>Payment Status</th>
                        <th class="text-center">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in applications" :key="index" class="table-row-hover">
                        <td class="ps-3">
                          <div class="form-check">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :value="item.id"
                                v-model="selectedApplications"
                                :disabled="parseFloat(item.licenceBillBalance) > 0">
                          </div>
                        </td>
                        <td>
                          <span class="text-muted">{{ ((currentPage - 1) * pageSize) + index + 1 }}</span>
                        </td>
                        <td>
                          <a href="javascript:void(0)" class="fw-semibold text-primary">
                            {{ item.licenceBillNo }}
                          </a>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-circle me-2">
                              {{ getInitials(item.businessName) }}
                            </div>
                            <div>
                              <h6 class="mb-0 fw-semibold">{{ item.businessName }}</h6>
                              <small class="text-muted">ID: {{ item.businessID }}</small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span class="fw-medium">{{ item.applicant }}</span>
                            <br>
                            <small class="text-muted">{{ item.phoneNumber }}</small>
                          </div>
                        </td>
                        <td>
                          <span class="badge bg-soft-info text-info">{{ item.licenceCategory }}</span>
                          <br>
                          <small class="text-muted">{{ item.licenceDuration }}</small>
                        </td>
                        <td>
                          <span>{{ item.subCountyName }}</span>
                          <br>
                          <small class="text-muted">{{ item.wardName }}</small>
                        </td>
                        <td>
                          <span class="text-muted">{{ formatDate(item.dateInspected) }}</span>
                        </td>
                        <td class="text-end">
                          <div>
                            <span class="fw-semibold">{{ formatCurrency(item.licenceDetailAmount) }}</span>
                            <br>
                            <small :class="parseFloat(item.licenceBillBalance) > 0 ? 'text-danger' : 'text-success'">
                              Bal: {{ formatCurrency(item.licenceBillBalance) }}
                            </small>
                          </div>
                        </td>
                        <td>
                          <span class="badge rounded-pill" :class="parseFloat(item.licenceBillBalance) < 1 ? 'bg-success' : 'bg-warning'">
                            {{ parseFloat(item.licenceBillBalance) < 1 ? 'Paid' : 'Unpaid' }}
                          </span>
                          <br>
                          <small class="text-muted">{{ item.status }}</small>
                        </td>
                        <td>
                          <div class="d-flex justify-content-center gap-1">
                            <button
                                @click="viewApplication(item)"
                                class="btn btn-icon btn-soft-primary"
                                title="View Details"
                                data-bs-toggle="modal"
                                data-bs-target="#approvalDetailModal">
                              <i class="bx bx-show"></i>
                            </button>
                            <button
                                v-if="parseFloat(item.licenceBillBalance) < 1"
                                @click="openSingleApproveModal(item)"
                                class="btn btn-icon btn-soft-success"
                                title="Approve Licence"
                                data-bs-toggle="modal"
                                data-bs-target="#approveModal">
                              <i class="bx bx-check"></i>
                            </button>
                            <button
                                v-else
                                class="btn btn-icon btn-soft-warning"
                                title="Payment Required"
                                disabled>
                              <i class="bx bx-lock"></i>
                            </button>
                            <button
                                @click="printViewBill(item)"
                                class="btn btn-icon btn-soft-info"
                                title="Print Invoice">
                              <i class="bx bx-printer"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <th colspan="2">{{ applications.length }} Applications</th>
                        <th colspan="3">Selected: {{ selectedApplications.length }}</th>
                        <th colspan="3">Total Pending Approval</th>
                        <th class="text-end">{{ formatCurrency(summary.totalPaid) }}</th>
                        <th colspan="2"></th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <!-- Card Footer - Pagination -->
                <div class="card-footer bg-white border-top" v-if="applications.length > 0">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div class="d-flex align-items-center">
                      <span class="text-muted me-2">Showing</span>
                      <span class="fw-semibold">{{ ((currentPage - 1) * pageSize) + 1 }}</span>
                      <span class="text-muted mx-1">to</span>
                      <span class="fw-semibold">{{ Math.min(currentPage * pageSize, totalItems) }}</span>
                      <span class="text-muted mx-1">of</span>
                      <span class="fw-semibold">{{ totalItems }}</span>
                      <span class="text-muted ms-1">entries</span>
                    </div>

                    <div class="d-flex align-items-center gap-2">
                      <select v-model="pageSize" class="form-select form-select-sm page-size-select">
                        <option value="10">10 / page</option>
                        <option value="25">25 / page</option>
                        <option value="50">50 / page</option>
                        <option value="100">100 / page</option>
                      </select>

                      <nav>
                        <ul class="pagination pagination-sm mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" href="javascript:void(0)" @click="prevPage">
                              <i class="bx bx-chevron-left"></i>
                            </a>
                          </li>
                          <li
                              v-for="page in visiblePages"
                              :key="page"
                              class="page-item"
                              :class="{ active: currentPage === page, disabled: page === '...' }">
                            <a class="page-link" href="javascript:void(0)" @click="page !== '...' && goToPage(page)">
                              {{ page }}
                            </a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" href="javascript:void(0)" @click="nextPage">
                              <i class="bx bx-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Single Approve Modal -->
      <div class="modal fade" id="approveModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-success text-white">
              <div class="d-flex align-items-center">
                <div class="modal-icon me-3">
                  <i class="bx bx-check-circle"></i>
                </div>
                <div>
                  <h5 class="modal-title mb-0">Approve Licence</h5>
                  <small class="opacity-75">Move to Stage 5 - Licence Issued</small>
                </div>
              </div>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div v-if="selectedApplication" class="mb-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="avatar-circle-lg me-3">
                    {{ getInitials(selectedApplication.businessName) }}
                  </div>
                  <div>
                    <h6 class="mb-0 fw-bold">{{ selectedApplication.businessName }}</h6>
                    <small class="text-muted">Business ID: {{ selectedApplication.businessID }}</small>
                  </div>
                </div>

                <div class="row g-3 mb-3">
                  <div class="col-6">
                    <label class="form-label small text-muted">Licence Bill No</label>
                    <p class="mb-0 fw-semibold">{{ selectedApplication.licenceBillNo }}</p>
                  </div>
                  <div class="col-6">
                    <label class="form-label small text-muted">Amount Paid</label>
                    <p class="mb-0 fw-semibold text-success">{{ formatCurrency(selectedApplication.licenceReceiptAmount) }}</p>
                  </div>
                  <div class="col-6">
                    <label class="form-label small text-muted">Licence Category</label>
                    <p class="mb-0">{{ selectedApplication.licenceCategory }}</p>
                  </div>
                  <div class="col-6">
                    <label class="form-label small text-muted">Duration</label>
                    <p class="mb-0">{{ selectedApplication.licenceDuration }}</p>
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label fw-semibold">Approval Remarks <span class="text-danger">*</span></label>
                  <textarea
                      v-model="approvalRemarks"
                      class="form-control"
                      rows="3"
                      placeholder="Enter approval remarks..."></textarea>
                </div>

                <div class="alert alert-soft-warning mb-0">
                  <i class="bx bx-info-circle me-2"></i>
                  This action will move the application to <strong>Stage 5 (Licence Issued)</strong> and allow printing of the permit.
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
              <button
                  type="button"
                  class="btn btn-success"
                  @click="approveSingleLicence"
                  :disabled="approving || !approvalRemarks">
                <span v-if="approving" class="spinner-border spinner-border-sm me-1"></span>
                <i v-else class="bx bx-check me-1"></i>
                {{ approving ? 'Approving...' : 'Approve Licence' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Bulk Approve Modal -->
      <div class="modal fade" id="bulkApproveModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-success text-white">
              <div class="d-flex align-items-center">
                <div class="modal-icon me-3">
                  <i class="bx bx-check-double"></i>
                </div>
                <div>
                  <h5 class="modal-title mb-0">Bulk Approve Licences</h5>
                  <small class="opacity-75">Approve {{ selectedApplications.length }} selected applications</small>
                </div>
              </div>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="text-center mb-4">
                <div class="bulk-count-badge">
                  {{ selectedApplications.length }}
                </div>
                <p class="text-muted mt-2">Applications will be moved to Stage 5</p>
              </div>

              <div class="mb-3">
                <label class="form-label fw-semibold">Approval Remarks <span class="text-danger">*</span></label>
                <textarea
                    v-model="bulkApprovalRemarks"
                    class="form-control"
                    rows="3"
                    placeholder="Enter remarks for all selected applications..."></textarea>
              </div>

              <div class="alert alert-soft-warning">
                <i class="bx bx-info-circle me-2"></i>
                This action will approve <strong>{{ selectedApplications.length }}</strong> licences and move them to Stage 5.
                This action cannot be undone.
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
              <button
                  type="button"
                  class="btn btn-success"
                  @click="bulkApproveLicences"
                  :disabled="approving || !bulkApprovalRemarks">
                <span v-if="approving" class="spinner-border spinner-border-sm me-1"></span>
                <i v-else class="bx bx-check-double me-1"></i>
                {{ approving ? 'Approving...' : 'Approve All Selected' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Application Detail Modal -->
      <div class="modal fade" id="approvalDetailModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <div class="d-flex align-items-center">
                <div class="modal-icon me-3">
                  <i class="bx bx-detail"></i>
                </div>
                <div>
                  <h5 class="modal-title mb-0">Application Details</h5>
                  <small class="opacity-75">{{ selectedApplication?.businessName }}</small>
                </div>
              </div>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body" v-if="selectedApplication">
              <div class="row g-4">
                <!-- Business Information -->
                <div class="col-md-6">
                  <div class="info-card">
                    <div class="info-card-header bg-primary-subtle">
                      <i class="bx bx-building-house text-primary me-2"></i>
                      <span class="fw-semibold text-primary">Business Information</span>
                    </div>
                    <div class="info-card-body">
                      <div class="info-row">
                        <span class="info-label">Business Name</span>
                        <span class="info-value fw-semibold">{{ selectedApplication.businessName }}</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Business ID</span>
                        <span class="info-value">{{ selectedApplication.businessID }}</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Applicant</span>
                        <span class="info-value">{{ selectedApplication.applicant }}</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Phone</span>
                        <span class="info-value">{{ selectedApplication.phoneNumber }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Location Information -->
                <div class="col-md-6">
                  <div class="info-card">
                    <div class="info-card-header bg-info-subtle">
                      <i class="bx bx-map text-info me-2"></i>
                      <span class="fw-semibold text-info">Location</span>
                    </div>
                    <div class="info-card-body">
                      <div class="info-row">
                        <span class="info-label">Sub County</span>
                        <span class="info-value">{{ selectedApplication.subCountyName }}</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Ward</span>
                        <span class="info-value">{{ selectedApplication.wardName }}</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Plot Number</span>
                        <span class="info-value">{{ selectedApplication.plotNumber || '-' }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Licence Information -->
                <div class="col-md-6">
                  <div class="info-card">
                    <div class="info-card-header bg-success-subtle">
                      <i class="bx bx-certification text-success me-2"></i>
                      <span class="fw-semibold text-success">Licence Information</span>
                    </div>
                    <div class="info-card-body">
                      <div class="info-row">
                        <span class="info-label">Licence Bill No</span>
                        <span class="info-value fw-semibold text-primary">{{ selectedApplication.licenceBillNo }}</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Category</span>
                        <span class="info-value">{{ selectedApplication.licenceCategory }}</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Sub Category</span>
                        <span class="info-value">{{ selectedApplication.licenceSubCategory }}</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Duration</span>
                        <span class="info-value">{{ selectedApplication.licenceDuration }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Payment Information -->
                <div class="col-md-6">
                  <div class="info-card">
                    <div class="info-card-header bg-warning-subtle">
                      <i class="bx bx-money text-warning me-2"></i>
                      <span class="fw-semibold text-warning">Payment Information</span>
                    </div>
                    <div class="info-card-body">
                      <div class="info-row">
                        <span class="info-label">Invoice Amount</span>
                        <span class="info-value">{{ formatCurrency(selectedApplication.licenceDetailAmount) }}</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Amount Paid</span>
                        <span class="info-value fw-semibold text-success">{{ formatCurrency(selectedApplication.licenceReceiptAmount) }}</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Balance</span>
                        <span class="info-value" :class="parseFloat(selectedApplication.licenceBillBalance) > 0 ? 'text-danger' : 'text-success'">
                          {{ formatCurrency(selectedApplication.licenceBillBalance) }}
                        </span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Date Inspected</span>
                        <span class="info-value">{{ formatDate(selectedApplication.dateInspected) }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Inspection Comments -->
                <div class="col-12" v-if="selectedApplication.comments">
                  <div class="info-card">
                    <div class="info-card-header bg-secondary-subtle">
                      <i class="bx bx-message-detail text-secondary me-2"></i>
                      <span class="fw-semibold text-secondary">Inspection Comments</span>
                    </div>
                    <div class="info-card-body">
                      <p class="mb-0">{{ selectedApplication.comments }}</p>
                    </div>
                  </div>
                </div>

                <!-- Minutes Information -->
                <div class="col-12" v-if="selectedApplication.minutesNumber">
                  <div class="info-card">
                    <div class="info-card-header bg-purple-subtle">
                      <i class="bx bx-file text-purple me-2"></i>
                      <span class="fw-semibold text-purple">Court Review</span>
                    </div>
                    <div class="info-card-body">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <span class="info-label">Minutes Number:</span>
                          <span class="info-value ms-2">{{ selectedApplication.minutesNumber }}</span>
                        </div>
                        <a v-if="selectedApplication.minutesFile"
                           :href="getMinutesFileUrl(selectedApplication.minutesFile)"
                           target="_blank"
                           class="btn btn-soft-primary btn-sm">
                          <i class="bx bx-download me-1"></i> Download Minutes
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
              <button
                  type="button"
                  class="btn btn-success"
                  @click="openSingleApproveFromDetail"
                  data-bs-dismiss="modal">
                <i class="bx bx-check me-1"></i> Approve Licence
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">County Billing System</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import { execute, biller, liquor, uploadsLiqour } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import ToolBarLiquor from "@/components/liquor/ToolBarLiquor.vue";
import moment from "moment";

export default {
  name: "PendingLicenceApproval",
  components: { NavigationBar, ToolBarLiquor },
  data() {
    return {
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems: 0,
      search: '',
      dateFrom: '',
      dateTo: '',
      paymentFilter: 'paid',
      loading: false,
      approving: false,
      message: null,
      applications: [],
      selectedApplication: null,
      selectedApplications: [],
      approvalRemarks: '',
      bulkApprovalRemarks: '',

      // Location filters
      subCounties: [],
      wards: [],
      subCounty: '',
      ward: '',

      summary: {
        totalCount: 0,
        totalInvoiced: 0,
        totalPaid: 0,
        totalBalance: 0
      },
      stats: {
        totalAtStage4: 0,
        pendingApproval: 0,
        awaitingPayment: 0,
        approvedToday: 0,
        approvedThisMonth: 0,
        pendingRevenue: 0,
        awaitingPaymentAmount: 0
      }
    }
  },
  computed: {
    isAllSelected() {
      const paidApplications = this.applications.filter(app => parseFloat(app.licenceBillBalance) < 1);
      return paidApplications.length > 0 &&
          this.selectedApplications.length === paidApplications.length;
    },
    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      if (start > 1) {
        pages.push(1);
        if (start > 2) pages.push('...');
      }

      for (let i = start; i <= end; i++) {
        if (i !== 1 && i !== this.totalPages) {
          pages.push(i);
        } else if (i === 1 && start === 1) {
          pages.push(i);
        } else if (i === this.totalPages && end === this.totalPages) {
          pages.push(i);
        }
      }

      if (end < this.totalPages) {
        if (end < this.totalPages - 1) pages.push('...');
        pages.push(this.totalPages);
      }

      return pages;
    }
  },
  mounted() {
    this.dateFrom = moment().subtract(1, 'year').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');

    this.getSubCounties();
    this.getApplications();
    this.getStats();
  },
  watch: {
    search(newVal) {
      this.currentPage = 1;
      this.getApplications();
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.currentPage = 1;
        this.getApplications();
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.currentPage = 1;
        this.getApplications();
      }
    },
    pageSize() {
      this.currentPage = 1;
      this.getApplications();
    },
    paymentFilter() {
      this.currentPage = 1;
      this.selectedApplications = [];
      this.getApplications();
    }
  },
  methods: {
    getInitials(name) {
      if (!name) return '??';
      const words = name.trim().split(' ');
      if (words.length >= 2) {
        return (words[0][0] + words[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      return moment(dateString).format('DD MMM YYYY');
    },

    formatCurrency(amount) {
      if (!amount) return 'KES 0';
      const num = parseFloat(amount);
      return 'KES ' + num.toLocaleString('en-KE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },

    getMinutesFileUrl(filename) {
      return uploadsLiqour + filename;
    },

    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedApplications = [];
      } else {
        this.selectedApplications = this.applications
            .filter(app => parseFloat(app.licenceBillBalance) < 1)
            .map(app => app.id);
      }
    },

    resetFilters() {
      this.search = '';
      this.dateFrom = moment().subtract(1, 'year').format('YYYY-MM-DD');
      this.dateTo = moment().format('YYYY-MM-DD');
      this.paymentFilter = 'paid';
      this.subCounty = '';
      this.ward = '';
      this.wards = [];
      this.selectedApplications = [];
      this.getApplications();
    },

    refreshData() {
      this.selectedApplications = [];
      this.getApplications();
      this.getStats();
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getApplications();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getApplications();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getApplications();
      }
    },

    // ---- Location filter methods (matching BillsRaised pattern) ----

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounty");

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties;
            }
          })
          .catch((e) => {
            console.error("Failed to load sub-counties:", e.message);
          });
    },

    getWards() {
      this.wards = [];
      this.ward = '';

      if (!this.subCounty?.subCountyID) return;

      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", this.subCounty.subCountyID);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards;
            }
          })
          .catch((e) => {
            console.error("Failed to load wards:", e.message);
          });
    },

    onSubCountyChange() {
      this.getWards();
      this.currentPage = 1;
      this.getApplications();
    },

    onWardChange() {
      this.currentPage = 1;
      this.getApplications();
    },

    // ---- End location filter methods ----

    getApplications() {
      this.loading = true;
      this.applications = [];
      const data = new FormData();
      data.append("function", "getApplicationsPendingLicenceApproval");
      data.append("search", this.search);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("paymentFilter", this.paymentFilter);
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("subCountyID", this.subCounty?.subCountyID || '');
      data.append("wardID", this.ward?.wardID || '');

      execute(data, liquor)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.applications = res.data.data.applications || [];
              this.totalItems = res.data.data.totalItems?.count || 0;
              this.totalPages = Math.ceil(this.totalItems / this.pageSize);
              this.summary = res.data.data.summary || {
                totalCount: 0,
                totalInvoiced: 0,
                totalPaid: 0,
                totalBalance: 0
              };
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
          });
    },

    getStats() {
      const data = new FormData();
      data.append("function", "getLicenceApprovalStats");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      execute(data, liquor)
          .then((res) => {
            if (res.data.success) {
              this.stats = res.data.data.stats || this.stats;
            }
          })
          .catch((e) => {
            console.error("Failed to load stats:", e.message);
          });
    },

    viewApplication(item) {
      this.selectedApplication = item;
    },

    openSingleApproveModal(item) {
      this.selectedApplication = item;
      this.approvalRemarks = '';
    },

    openSingleApproveFromDetail() {
      this.approvalRemarks = '';
      setTimeout(() => {
        const modal = new window.bootstrap.Modal(document.getElementById('approveModal'));
        modal.show();
      }, 300);
    },

    showBulkApproveModal() {
      this.bulkApprovalRemarks = '';
      const modal = new window.bootstrap.Modal(document.getElementById('bulkApproveModal'));
      modal.show();
    },

    approveSingleLicence() {
      if (!this.approvalRemarks) {
        alert("Please enter approval remarks");
        return;
      }

      this.approving = true;
      const data = new FormData();
      data.append("function", "approveLicence");
      data.append("id", this.selectedApplication.id);
      data.append("approvedBy", sessionStorage.getItem("sessionNames"));
      data.append("approvedByIdNo", sessionStorage.getItem("sessionIdNo"));
      data.append("approvalRemarks", this.approvalRemarks);

      execute(data, liquor)
          .then((res) => {
            this.approving = false;
            if (res.data.success) {
              const modal = window.bootstrap.Modal.getInstance(document.getElementById('approveModal'));
              if (modal) modal.hide();
              alert("Licence approved successfully!");
              this.refreshData();
            } else {
              alert(res.data.message || "Failed to approve licence");
            }
          })
          .catch((e) => {
            this.approving = false;
            alert("Error: " + e.message);
          });
    },

    bulkApproveLicences() {
      if (!this.bulkApprovalRemarks) {
        alert("Please enter approval remarks");
        return;
      }

      if (this.selectedApplications.length === 0) {
        alert("No applications selected");
        return;
      }

      this.approving = true;
      const data = new FormData();
      data.append("function", "bulkApproveLicences");
      data.append("applicationIDs", JSON.stringify(this.selectedApplications));
      data.append("approvedBy", sessionStorage.getItem("sessionNames"));
      data.append("approvedByIdNo", sessionStorage.getItem("sessionIdNo"));
      data.append("approvalRemarks", this.bulkApprovalRemarks);

      execute(data, liquor)
          .then((res) => {
            this.approving = false;
            if (res.data.success) {
              const modal = window.bootstrap.Modal.getInstance(document.getElementById('bulkApproveModal'));
              if (modal) modal.hide();
              const approvedCount = res.data.data.approvedCount || this.selectedApplications.length;
              alert(`${approvedCount} licence(s) approved successfully!`);
              this.selectedApplications = [];
              this.refreshData();
            } else {
              alert(res.data.message || "Failed to approve licences");
            }
          })
          .catch((e) => {
            this.approving = false;
            alert("Error: " + e.message);
          });
    },

    printViewBill(item) {
      if (item.licenceBillNo) {
        localStorage['params'] = JSON.stringify({ billNo: item.licenceBillNo });
        const routeData = this.$router.resolve({ name: 'bill' });
        window.open(routeData.href, '_blank');
      } else {
        alert("No licence bill found for this application");
      }
    }
  }
}
</script>

<style scoped>
/* Page Header */
.page-header-box {
  background: #f8f9fa;
  padding: 20px 24px;
  border-radius: 0;
  border-bottom: 3px solid #1a2b4a;
}

.page-header-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a2b4a;
  margin-bottom: 4px;
  letter-spacing: 0.5px;
}

.page-header-description {
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 0;
}

/* Statistics Cards */
.stats-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  transition: transform 0.2s, box-shadow 0.2s;
}

.stats-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.12);
}

.stats-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #0061f2 0%, #00d2ff 100%);
}

.bg-gradient-success {
  background: linear-gradient(135deg, #00b894 0%, #00cec9 100%);
}

.bg-gradient-warning {
  background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
}

.bg-gradient-info {
  background: linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%);
}

/* Header Icon */
.header-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
}

/* Search Box */
.search-box {
  position: relative;
  width: 220px;
}

.search-box input {
  padding-left: 35px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.search-box .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
}

/* Date Input */
.date-input {
  width: auto;
}

.date-input .input-group-text {
  background: #f8fafc;
  border-color: #e2e8f0;
  font-size: 12px;
  font-weight: 600;
}

.date-input input {
  border-color: #e2e8f0;
  font-size: 13px;
}

/* Avatar Circle */
.avatar-circle {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 12px;
  flex-shrink: 0;
}

.avatar-circle-lg {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
}

/* Table Row Hover */
.table-row-hover:hover {
  background-color: #fffbf0 !important;
}

/* Icon Buttons */
.btn-icon {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 16px;
}

.btn-soft-primary {
  background-color: rgba(0, 97, 242, 0.1);
  color: #0061f2;
  border: none;
}

.btn-soft-primary:hover {
  background-color: #0061f2;
  color: white;
}

.btn-soft-success {
  background-color: rgba(0, 184, 148, 0.1);
  color: #00b894;
  border: none;
}

.btn-soft-success:hover {
  background-color: #00b894;
  color: white;
}

.btn-soft-info {
  background-color: rgba(108, 92, 231, 0.1);
  color: #6c5ce7;
  border: none;
}

.btn-soft-info:hover {
  background-color: #6c5ce7;
  color: white;
}

/* Badges */
.bg-soft-warning {
  background-color: rgba(225, 112, 85, 0.1) !important;
}

.bg-soft-success {
  background-color: rgba(0, 184, 148, 0.1) !important;
}

.bg-soft-info {
  background-color: rgba(108, 92, 231, 0.1) !important;
}

/* Empty State */
.empty-state-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  background: linear-gradient(135deg, #00b894 0%, #00cec9 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: white;
}

/* Pagination */
.page-size-select {
  width: auto;
  min-width: 100px;
}

.pagination .page-link {
  border-radius: 6px;
  margin: 0 2px;
  border: none;
  color: #64748b;
}

.pagination .page-item.active .page-link {
  background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
  color: white;
}

/* Modal Styles */
.modal-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
}

/* Bulk Count Badge */
.bulk-count-badge {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  background: linear-gradient(135deg, #00b894 0%, #00cec9 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 700;
  color: white;
}

/* Info Cards */
.info-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  height: 100%;
}

.info-card-header {
  padding: 10px 15px;
  display: flex;
  align-items: center;
  font-size: 13px;
}

.info-card-body {
  padding: 12px 15px;
  background: white;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #f1f5f9;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 12px;
  color: #64748b;
}

.info-value {
  font-size: 13px;
  color: #1a2b4a;
  text-align: right;
}

/* Alert Soft Styles */
.alert-soft-warning {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.2);
  color: #d97706;
  border-radius: 10px;
}

/* Subtle Background Colors */
.bg-primary-subtle {
  background: rgba(99, 102, 241, 0.1);
}

.bg-info-subtle {
  background: rgba(6, 182, 212, 0.1);
}

.bg-success-subtle {
  background: rgba(16, 185, 129, 0.1);
}

.bg-warning-subtle {
  background: rgba(245, 158, 11, 0.1);
}

.bg-secondary-subtle {
  background: rgba(100, 116, 139, 0.1);
}

.bg-purple-subtle {
  background: rgba(139, 92, 246, 0.1);
}

.text-purple {
  color: #8b5cf6;
}

/* Filter section labels */
.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}
</style>